import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { getDisplayUrl, getModalBorder } from './helpers';

const UrlRow = ({ label, url, onCopyUrl }) => {
	if (!url) {
		return null;
	}

	return (
		<Box
			sx={{
				px: 1.5,
				py: 1.25,
				borderRadius: 1.5,
				border: '1px solid',
				borderColor: (theme) => getModalBorder(theme),
				background: (theme) =>
					theme.palette.mode === 'dark'
						? alpha(theme.palette.common.white, 0.03)
						: alpha(theme.palette.common.black, 0.02),
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 1
			}}
		>
			<Box sx={{ minWidth: 0, flex: 1 }}>
				<Typography
					variant="caption"
					sx={{
						color: 'text.secondary',
						fontWeight: 600,
						letterSpacing: '0.06em',
						textTransform: 'uppercase',
						fontSize: '1.2rem'
					}}
				>
					{label}
				</Typography>
				<Tooltip title={url}>
					<Typography
						variant="body2"
						fontWeight={600}
						sx={{
							mt: 0.25,
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap',
							fontSize: '1.4rem'
						}}
					>
						{getDisplayUrl(url)}
					</Typography>
				</Tooltip>
			</Box>
			<Tooltip title="Copy URL">
				<IconButton
					size="small"
					onClick={() => onCopyUrl(url)}
					sx={{
						border: '1px solid',
						borderColor: (theme) => getModalBorder(theme),
						borderRadius: 1.25,
						flexShrink: 0
					}}
				>
					<ContentCopyIcon sx={{ fontSize: 15 }} />
				</IconButton>
			</Tooltip>
		</Box>
	);
};

export default UrlRow;
